import * as d3 from 'd3';

export default class Abstract {
  constructor(props) {
    this.props = props;
    this.rangeStart = 0;
    this.rangeEnd = props.options.width;
    this.range = [this.rangeStart, this.rangeEnd];
    this.transitionDuration = 500;
  }

  get xScale() {
    return d3.scaleTime().domain(this.domain).range(this.range);
  }

  get yScale() {
    const {
      rows,
      data,
      options: { padding, height },
    } = this.props;

    return d3
      .scaleLinear()
      .domain([0, data.rows.length])
      .range([0 + padding, height]);
  }

  get domain() {
    const { startDate, monthCount, weekCount, scaleType } = this.props.options;
    const startYear = d3.timeYear.floor(startDate);
    const startMonth = d3.timeMonth.floor(startDate);
    const startWeek = d3.timeWeek.floor(startDate);

    if (scaleType === 'month') {
      return [
        d3.timeMonth.offset(startMonth, -1),
        d3.timeMonth.offset(startMonth, monthCount - 1),
      ];
    }

    if (scaleType === 'quarter') {
      return [
        d3.timeMonth.offset(startMonth, -3),
        d3.timeMonth.offset(startMonth, monthCount - 3),
      ];
    }

    if (scaleType === 'year') {
      return [
        d3.timeYear.offset(startYear, -1),
        d3.timeYear.offset(startYear, 3),
      ];
    }

    return [
      d3.timeWeek.offset(startWeek, -1),
      d3.timeWeek.offset(startWeek, weekCount - 1),
    ];
  }

  update() {
    return false;
  }
}
